import { LogLevel } from "angular-auth-oidc-client";

export const environment = {
    production: false,
    identityConfig: {
        authority: 'https://identity.nside.io',
        redirectUrl: `https://tips-dash-v2.nside.io/redirect`,
        postLogoutRedirectUri: 'https://v2.nside.io/Default.aspx',
        clientId: 'tips-dash.nside.io',
        scope: 'api.nside.io openid roles profile offline_access',
        responseType: 'code',
        silentRenew: true,
        silentRenewUrl: `https://tips-dash-v2.nside.io/silent-renew`,
        useRefreshToken: true,
        renewTimeBeforeTokenExpiresInSeconds: 30,
        logLevel: LogLevel.Debug
    },
    apiBaseUrl: 'https://tips-v2.nside.io',
    assessApiBaseUrl: 'https://assess-api.nside.io'
};